import { calculateDistance } from "../calculateDistance";

// Total distance
export const getTotalDistance = (points) =>
  points.reduce(
    (sum, point, i) =>
      i === 0
        ? 0
        : sum +
          calculateDistance(
            points[i - 1].lat,
            points[i - 1].lng,
            point.lat,
            point.lng
          ),
    0
  );
